import { render } from "./CustomerSalesReport.vue?vue&type=template&id=48998bc9"
import script from "./CustomerSalesReport.vue?vue&type=script&lang=js"
export * from "./CustomerSalesReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__